import { onCLS, onFCP, onINP, onLCP, onTTFB, type Metric } from "web-vitals";

import { reportProblem } from "./clientLog";

// Story jve-4-4 — wire the browser's global problem signals to the sink:
//   - uncaught errors (window 'error')
//   - unhandled promise rejections ('unhandledrejection')
//   - Core Web Vitals + a couple of loading metrics (web-vitals)
// React render errors are caught separately by ErrorBoundary. Install once from
// the app entry point (main.tsx).

let installed = false;

function reportVital(metric: Metric): void {
  reportProblem({ type: "web-vital", name: metric.name, value: metric.value });
}

export function installProblemTracking(): void {
  if (installed) {
    return;
  }
  installed = true;

  window.addEventListener("error", (event: ErrorEvent) => {
    reportProblem({
      type: "error",
      name: event.error?.name ?? "Error",
      message: event.message,
      stack: event.error?.stack,
      url: location.pathname,
    });
  });

  window.addEventListener("unhandledrejection", (event: PromiseRejectionEvent) => {
    const reason: unknown = event.reason;
    const asError = reason instanceof Error ? reason : undefined;
    reportProblem({
      type: "unhandledrejection",
      name: asError?.name ?? "UnhandledRejection",
      message: asError?.message ?? (typeof reason === "string" ? reason : String(reason)),
      stack: asError?.stack,
      url: location.pathname,
    });
  });

  // web-vitals invokes each callback when its metric is ready (and on
  // visibility-change finalisation). Each maps to a `web-vital` report.
  onCLS(reportVital);
  onINP(reportVital);
  onLCP(reportVital);
  onFCP(reportVital);
  onTTFB(reportVital);
}
